export default "__VITE_ASSET__eea96d86__"